import classNames from 'classnames';

import { Modal, ModalContent, ModalControllerProps } from '@uikit';

const CreateNewAccountModal = ({
  modalProps,
  onConfirm,
  onClose,
}: {
  modalProps: ModalControllerProps;
  onConfirm: (isCreateNew: boolean) => void;
  onClose: () => void;
}) => {
  return (
    <Modal {...modalProps}>
      <ModalContent
        className={classNames(
          'rounded-xl p-0 flex-row border-none overflow-hidden gap-0 text-center max-w-[400px]',
        )}
      >
        <div className="flex flex-col p-8">
          <p className="font-semibold">
            We couldn't find your account. Would you like to register a new one?
          </p>
          <div className="flex gap-5 justify-center pt-5">
            <button onClick={onClose} className="button button-primary button-lg">
              Cancel
            </button>
            <button onClick={() => onConfirm(true)} className="button button-primary button-lg">
              Create
            </button>
          </div>
        </div>
      </ModalContent>
    </Modal>
  );
};

export default CreateNewAccountModal;
